import React from 'react';
import { useSearchSuggestionItemClassName } from './utils';
import { highlightMatch } from '../utils';
import { SearchSuggestionItemLabelTypography, SearchSuggestionItemContainer, SearchSuggestionItemRoot, SearchSuggestionsItemAction, SearchSuggestionsItemIcon, SearchSuggestionsItemLabel } from './style';
import { SEARCH_CLASS_PREFIX } from '../constants';
export var SearchSuggestionItem = function SearchSuggestionItem(_ref) {
  var className = _ref.className,
      option = _ref.option,
      optionIndex = _ref.optionIndex,
      suggestionIndex = _ref.suggestionIndex,
      handleSuggestionClick = _ref.handleSuggestionClick,
      additionalInfo = _ref.additionalInfo,
      renderItemAdditionalInfo = _ref.renderItemAdditionalInfo,
      icon = _ref.icon,
      renderItemIcon = _ref.renderItemIcon,
      cursor = _ref.cursor,
      searchQuery = _ref.searchQuery,
      theme = _ref.theme;
  var classOverride = useSearchSuggestionItemClassName(SEARCH_CLASS_PREFIX, className);

  var handleOnClick = function handleOnClick(index) {
    return function (event) {
      return handleSuggestionClick(event, index);
    };
  };

  var getSuggestionItemClass = function getSuggestionItemClass(index) {
    return "".concat(classOverride.SuggestionsItem, " ").concat(cursor === index ? 'suggestion-focused' : '');
  };

  return React.createElement(SearchSuggestionItemRoot, {
    className: getSuggestionItemClass(suggestionIndex),
    theme: theme
  }, React.createElement(SearchSuggestionItemContainer, {
    className: classOverride.SuggestionItemContainer,
    isHighlighted: cursor === suggestionIndex,
    theme: theme
  }, !!(icon || renderItemIcon) && React.createElement(SearchSuggestionsItemIcon, {
    className: classOverride.SuggestionsItemIcon,
    icon: icon,
    renderItemIcon: renderItemIcon,
    theme: theme
  }, renderItemIcon && renderItemIcon(option, optionIndex) || icon), React.createElement(SearchSuggestionsItemLabel, {
    renderItemAdditionalInfo: renderItemAdditionalInfo,
    className: classOverride.SuggestionsItemLabel,
    onClick: handleOnClick(suggestionIndex),
    theme: theme
  }, React.createElement(SearchSuggestionItemLabelTypography, {
    className: classOverride.LabelTypography,
    paragraph: true,
    medium: true,
    theme: theme
  }, highlightMatch(option.label, searchQuery))), (renderItemAdditionalInfo || additionalInfo) && React.createElement(SearchSuggestionsItemAction, {
    renderItemAdditionalInfo: renderItemAdditionalInfo,
    className: classOverride.SuggestionsItemAction,
    theme: theme
  }, renderItemAdditionalInfo && renderItemAdditionalInfo(option) || additionalInfo)));
};